import { render, staticRenderFns } from "./DrawerNotification.vue?vue&type=template&id=388e6046&scoped=true"
import script from "./DrawerNotification.js?vue&type=script&lang=js&external"
export * from "./DrawerNotification.js?vue&type=script&lang=js&external"
import style0 from "./DrawerNotification.vue?vue&type=style&index=0&id=388e6046&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388e6046",
  null
  
)

export default component.exports